var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('h1',[_vm._v("ТОП 100 Теги сайтов")]),_c('p',[_vm._v("Страница для управления тегами сайтов ТОП 100")])])}
var staticRenderFns = []

export { render, staticRenderFns }